import {
  Template,
  Template_TemplateType,
} from '@weave/schema-gen-ts/dist/schemas/reviews/landing-page-templates/v1/landing_page_template_service.pb';

// TODO: get rid of one of these after BE changes for landingPageTemplate types
export enum AffiliateReviewType {
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
}
export enum AffiliateReviewIds {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
}

export type ReviewTemplateTypes = Template_TemplateType | AffiliateReviewType;

export type ReviewLandingPageTemplate = Required<
  Pick<Template, 'templateId' | 'title' | 'previewLink' | 'htmlConfig' | 'renderedHtml'>
> & {
  type: ReviewTemplateTypes;
};
